class ScrollFade {
    constructor(targetClass = '.js-scroll-fade') {
        this.ANIMATION_CLASS = 'is-animation';

        let $section = document.querySelectorAll(`${targetClass}:not(.is-animation), .js-scroll-fade2:not(.is-animation), .js-scroll-img1:not(.is-animation), .js-scroll-side:not(.is-animation), .js-scroll-opacity:not(.is-animation),.js-scroll-c:not(.is-animation), .js-scroll-from-left:not(.is-animation), .js-scroll-from-right:not(.is-animation), .js-scroll-from-bottom:not(.is-animation)`);
        if($section.length === null) {
            return;
        }
        let controller = new ScrollMagic.Controller();
        // window.scrollController.push(controller);
        for(let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: 'onEnter',
                reverse: false,
                offset: 250
            })
                //.addIndicators({name: '____HRERE333'}) // add indicators (requires plugin)
                .addTo(controller);
            scene.on('enter', ()=>{
                $section[i].classList.add(this.ANIMATION_CLASS);
                if($($section[i]).hasClass('is-reshash')) {
                    $($section[i]).find('.plan-detail__include-slash').addClass('is-animation');
                }
            });
            scene.on('leave', ()=>{
                // $section[i].classList.remove(this.ANIMATION_CLASS);
            });
            scene.on('end', ()=>{
                scene.destroy(true);
            });
        }
    }
}


export default ScrollFade;
